import {
  AgentCustomersStatsVDriveResponse,
  Box,
  Disclaimer,
  displayCentsInDollars,
  Div,
  H5,
  lightTheme,
  P,
  Separator,
  TooltipIcon,
  VerticalSeparator,
} from '@vgrubs/components';

export default function VDriveStatItem({
  location,
}: {
  location: AgentCustomersStatsVDriveResponse;
}) {
  return (
    <Box $boxNoShadow $p="12px 16px">
      <Div $relative>
        <Div $flex $column>
          <Div $width="100%" $flex $alignStart $between $gap="8px" $mb="2">
            <H5 $m="0">{location.locationName}</H5>
            <TooltipIcon tooltip="Additional income generated by reduced third-party commissions and delivery fee savings." />
          </Div>
          <Div $flex $gap="8px">
            <P $m="0">Total Gain:</P>
            <P $m="0" $color={lightTheme.green}>
              {displayCentsInDollars(location.totalGain)}
            </P>
          </Div>
        </Div>
      </Div>

      <Separator $m="12px 0" />

      <Div $flex>
        <Div $relative style={{ flex: 1 }}>
          <Div $width="100%" $flex $alignStart $between $gap="8px">
            <Disclaimer $m="0">Increase Gross Revenue</Disclaimer>
            <TooltipIcon tooltip="Restaurants using vDrive typically experience higher gross deposits from third-party platforms. This results from collecting delivery fees and tips directly, along with reduced third-party commission expenses." />
          </Div>
          <Disclaimer $m="0">
            Sales: {displayCentsInDollars(location.totalIncreaseInGrossSales)}
          </Disclaimer>

          <Div $absolute $right="0" $bottom="0"></Div>
        </Div>

        <VerticalSeparator $m="0 12px" />

        <Div style={{ flex: 1 }}>
          <Div $relative>
            <Div $width="100%" $flex $alignStart $between $gap="8px">
              <Disclaimer $m="0">Total vDrive Cost</Disclaimer>
              <TooltipIcon tooltip="Represents the deduction for vDrive-related expenses, including delivery costs and driver tip payouts." />
            </Div>
            <Disclaimer $m="0">
              Cost: {displayCentsInDollars(location.totalVDriveCost)}
            </Disclaimer>

            <Div $absolute $right="0" $bottom="0"></Div>
          </Div>
        </Div>
      </Div>
    </Box>
  );
}
